var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 10.5C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8284 1.17157 13.5 2 13.5V10.5ZM35.0607 13.0607C35.6464 12.4749 35.6464 11.5251 35.0607 10.9393L25.5147 1.3934C24.9289 0.807612 23.9792 0.807612 23.3934 1.3934C22.8076 1.97918 22.8076 2.92893 23.3934 3.51472L31.8787 12L23.3934 20.4853C22.8076 21.0711 22.8076 22.0208 23.3934 22.6066C23.9792 23.1924 24.9289 23.1924 25.5147 22.6066L35.0607 13.0607ZM2 13.5H34V10.5H2V13.5Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"36","height":"24","viewBox":"0 0 36 24","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
